import { useSideDrawer } from '@/domain/hooks/useSideDrawer'
import TransferIcon from '@/ui/assets/components/transfer.inline.svg'
import { Button } from '@/ui/atoms/button/Button'
import { ArrowUpDownIcon, LucideIcon } from 'lucide-react'
import { FC, PropsWithChildren, SVGProps, useState } from 'react'
import { TransferDialog } from './dialogs/TransferDialog'

export function ButtonGroup() {
  const [isTransferDialogOpen, setIsTransferDialogOpen] = useState(false)
  const { swapDialog } = useSideDrawer()

  return (
    <div className="flex gap-3">
      <QuickActionButton onClick={() => swapDialog.open()} Icon={ArrowUpDownIcon}>
        Swap
      </QuickActionButton>
      <QuickActionButton onClick={() => setIsTransferDialogOpen(true)} Icon={TransferIcon}>
        Transfer
      </QuickActionButton>

      <TransferDialog open={isTransferDialogOpen} setOpen={setIsTransferDialogOpen} />
    </div>
  )
}

interface QuickActionButtonProps extends PropsWithChildren {
  Icon: LucideIcon | FC<SVGProps<SVGElement>>
  onClick: () => void
}

function QuickActionButton({ children, Icon, onClick }: QuickActionButtonProps) {
  return (
    <Button
      className="flex flex-1 items-center gap-3 rounded-sm border border-primary/10 bg-primary/5 px-4 py-3.5 text-primary text-sm transition-colors hover:bg-primary/10 hover:text-primary"
      onClick={onClick}
    >
      <Icon className="h-5 w-5" />
      {children}
    </Button>
  )
}
